// var totalSlides = $('#ourServicesSlider > .slick-slide').length;
var totalSlides = document.querySelectorAll('#ourServicesSlider .card').length;
jQuery('#ourServicesSlider').slick({
    slidesToShow: (totalSlides >= 5) ? 4 : totalSlides,
    slidesToScroll: 1,
    autoplay: false,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    infinite: false,
    prevArrow: jQuery(".our-services-slider-prev"),
    nextArrow: jQuery(".our-services-slider-next"),
    pauseOnHover: true,
    // focusOnSelect: true,
    pauseOnFocus: true,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: (totalSlides >= 5) ? 4 : totalSlides,
            }
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: (totalSlides >= 3) ? 3 : totalSlides,
            }
        },
        {
            breakpoint: 678,
            settings: {
                slidesToShow: (totalSlides >= 2) ? 2 : totalSlides,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});

jQuery('#ourServicesSlider .slick-slide').on('click', function() {
    var index = jQuery(this).data('slick-index');

    openCard(index);
});


jQuery('#ourServicesSlider .service-open').on('click', function() {
    var index = jQuery(this).parent().parent().parent().data('slick-index');

    openCard(index);
});

function openCard(index) {
    var slideCount = jQuery('#ourServicesSlider')[0].slick["slideCount"];
    index = index + 1;

    jQuery('.modal-backdrop').fadeIn();
    jQuery('.our-service-modal[data-modal-id="'+index+'"]').css('display', 'flex').hide().fadeIn();
}

jQuery('#ourServicesSlider .service-close').on('click', function() {
    var card = jQuery(this).attr('data-id');

    var oldWidth = jQuery('#ourServicesSlider .card[data-id="'+card+'"]').first().parent().parent().attr('data-oldwidth');
    jQuery('#ourServicesSlider .card[data-id="'+card+'"]').first().parent().parent().animate({width: oldWidth + 'px'}, 500, function() { });

    // jQuery(this).hide();
    jQuery('#ourServicesSlider .service-close[data-id="'+card+'"]').hide();
    jQuery('#ourServicesSlider .service-open[data-id="'+card+'"]').show();

    jQuery('#ourServicesSlider .card[data-id="'+card+'"] .overlay').first().fadeToggle("slow");
    jQuery('#ourServicesSlider .card[data-id="'+card+'"] .vertical').first().fadeToggle("slow");
});

$('#ourServicesSlider').on('beforeChange', function(event, { slideCount: count }, currentSlide, nextSlide){
    jQuery('#ourServicesSlider .slick-slide').each(function() {
        var oldWidth = jQuery(this).attr('data-oldwidth');
        var card = jQuery(this).find('.service-open').attr('data-id');
        if (oldWidth) {
            jQuery(this).animate({width: oldWidth + 'px'}, 500, function() {  });

            jQuery('#ourServicesSlider .service-close[data-id="'+card+'"]').hide();
            jQuery('#ourServicesSlider .service-open[data-id="'+card+'"]').show();

            jQuery('#ourServicesSlider .card[data-id="'+card+'"] .overlay').first().fadeToggle("slow");
            jQuery('#ourServicesSlider .card[data-id="'+card+'"] .vertical').first().fadeToggle("slow");

            jQuery(this).removeAttr('data-oldwidth');
        }
    });
});

jQuery('.modal-backdrop').click(function() {
    jQuery('.our-service-modal').fadeOut();
    jQuery(this).fadeOut();
});

jQuery('.our-service-modal .close-modal').click(function() {
    jQuery('.our-service-modal').fadeOut();
    jQuery('.modal-backdrop').fadeOut();
});

jQuery('.our-service-modal').click(function(e) {
    if (e.target != this) {
        return false;
    }

    jQuery('.our-service-modal').fadeOut();
    jQuery('.modal-backdrop').fadeOut();
});